import { Link } from "react-router-dom";
import { Type, Moon, Hash, Shapes, Brain, ArrowLeft, Sparkles } from "lucide-react";

const games = [
  { to: "/games/alphabet", label: "Alphabet & Phonics", desc: "Tap a letter, hear it come alive.", icon: Type, bg: "bg-brand-red", text: "text-white" },
  { to: "/games/islamic", label: "Islamic Basics", desc: "Arabic alphabet, duas, and colors.", icon: Moon, bg: "bg-brand-green", text: "text-white" },
  { to: "/games/counting", label: "Counting Fun", desc: "How many friends do you see?", icon: Hash, bg: "bg-brand-yellow", text: "text-brand-ink" },
  { to: "/games/shapes", label: "Shapes & Colors", desc: "Match the color, spot the shape.", icon: Shapes, bg: "bg-brand-purple", text: "text-brand-ink" },
  { to: "/games/memory", label: "Memory Pairs", desc: "Flip cards and find the pairs.", icon: Brain, bg: "bg-brand-blue", text: "text-brand-ink" },
];

export default function GamesHub() {
  return (
    <main className="mx-auto max-w-6xl px-6 py-12 md:py-16" data-testid="games-hub">
      <Link to="/" className="inline-flex items-center gap-2 text-brand-ink/80 hover:text-brand-red font-bold" data-testid="games-back-home">
        <ArrowLeft size={18} /> Back home
      </Link>

      <div className="mt-6 max-w-2xl">
        <span className="inline-flex items-center gap-2 rounded-full border-2 border-brand-ink bg-brand-yellow px-4 py-1.5 font-bold text-brand-ink text-sm shadow-brutal-sm">
          <Sparkles size={16} /> Play & Learn
        </span>
        <h1 className="mt-4 font-display text-5xl md:text-6xl font-bold text-brand-ink leading-tight">
          Pick a game. <span className="text-brand-red">Have a giggle.</span>
        </h1>
        <p className="mt-3 text-lg text-brand-ink/80">
          Five little activities designed for our 3–4 year old friends. Grown-ups, please sit close by!
        </p>
      </div>

      <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {games.map((g) => {
          const Icon = g.icon;
          return (
            <Link
              key={g.label}
              to={g.to}
              data-testid={`hub-card-${g.label.toLowerCase().replace(/\s|&/g, "")}`}
              className={`group relative rounded-3xl border-[3px] border-brand-ink ${g.bg} ${g.text} p-7 shadow-brutal lift-hover overflow-hidden`}
            >
              <div className="absolute -right-10 -bottom-10 w-40 h-40 rounded-full bg-white/25" />
              <div className="w-16 h-16 rounded-2xl bg-white border-2 border-brand-ink flex items-center justify-center">
                <Icon size={30} strokeWidth={2.5} className="text-brand-ink" />
              </div>
              <h3 className="mt-5 font-display text-2xl font-semibold leading-tight">{g.label}</h3>
              <p className={`mt-1 text-sm font-semibold ${g.text === "text-white" ? "text-white/90" : "text-brand-ink/70"}`}>
                {g.desc}
              </p>
              <p className="mt-6 inline-flex items-center gap-1 font-bold text-sm group-hover:gap-2 transition-all">Start playing →</p>
            </Link>
          );
        })}
      </div>
    </main>
  );
}
